import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../../../loader/Loader";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Sellers from "./Sellers";
import Marketers from "./Marketers";
import Fulfillment from "./Fulfillment";
import { Tabs } from "@mantine/core";
import StatisticsSearchComponent from "../search components/StatisticsSearchComponent";
import { useTranslation } from "react-i18next";

const PaymentRequest = () => { 
  const { lang } = useParams();
  const [_] = useTranslation("global");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [search, handleSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const box_head_dir = lang === "en" ? "ltr" : "rtl";

  return (
    <div className="flex-grow-1 stats-component" dir={box_head_dir}>
      <Helmet>
        <title>{_("panel.paymentRequest")}</title>
      </Helmet>
      <Button
        className="fs-5 w-25 mb-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => {
          handleSearch(!search);
        }}
      >
        {_("panel.search")}
      </Button>
      {search ? <StatisticsSearchComponent type={"payment"} /> : ""}

      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <Loader active={loading} />

        <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
          <h3 className="fs-2 mb-4" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("panel.paymentRequest")}
          </h3>
        </div>

        <Tabs defaultValue="gallery">
          <Tabs.List grow>
            <Tabs.Tab
              value="gallery"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.marketers")}
            </Tabs.Tab>
            <Tabs.Tab
              value="messages"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.sellers")}
            </Tabs.Tab>
            <Tabs.Tab
              value="fulfillment"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.fulfillment")}
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="gallery">
            <Marketers />
          </Tabs.Panel>

          <Tabs.Panel value="messages">
            <Sellers />
          </Tabs.Panel>

          <Tabs.Panel value="fulfillment">
            <Fulfillment />
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
};

export default PaymentRequest;
